export const DEFAULT_LOGIN_SUPPORT_STYLE = "bars";

export const normalizeLoginSupportStyle = (
  value?: string,
): "icon-line" | "bars" | "skysupport" => {
  const trimmed = String(value || "").trim();
  if (trimmed === "icon-line") return "icon-line";
  if (trimmed === "skysupport") return "skysupport";
  return DEFAULT_LOGIN_SUPPORT_STYLE;
};

export const telegramHandleLabel = (value?: string) => {
  const handle = String(value || "")
    .trim()
    .replace(/^@/, "");
  return handle ? `t.me/${handle}` : "";
};

export function getContactValues(value: unknown): string[] {
  if (Array.isArray(value)) {
    return value.map((item) => String(item || "").trim()).filter(Boolean);
  }
  const text = String(value || "").trim();
  return text ? [text] : [];
}

export function isContactShowing(site: any, key: string): boolean {
  const value = site?.contactShowing?.[key];
  if (
    !value ||
    value === false ||
    value === "false" ||
    value === 0 ||
    value === "0"
  )
    return false;
  return true;
}

export function getVisibleContacts(site: any, key: string): string[] {
  if (!isContactShowing(site, key)) return [];
  return getContactValues(site?.[key]);
}

export function getContactChannel(site: any, key: string) {
  return {
    showing: isContactShowing(site, key),
    values: getContactValues(site?.[key]),
  };
}

export function isSignupShowing(site: any): boolean {
  const value = site?.contactShowing?.signup;
  return value === true || value === "true" || value === 1;
}

export function normalizeExternalHref(value: unknown): string {
  const raw = String(value || "").trim();
  if (!raw) return "";
  if (/^https?:\/\//i.test(raw)) return raw;
  if (raw.startsWith("/") && !raw.startsWith("//")) return raw;
  if (/^[\w.-]+\.[a-z]{2,}([/:?#].*)?$/i.test(raw)) return `https://${raw}`;
  return "";
}

export function getSignupHref(site: any): string {
  return normalizeExternalHref(site?.signup);
}

export function getAppLinkHref(site: any): string {
  return normalizeExternalHref(site?.appLink);
}

export function getViewAllLinksHref(site: any): string {
  return normalizeExternalHref(site?.viewAllLinks);
}
